import React, { lazy } from "react";
let generation = 0;
export function retryFailedRouteLoads() { generation += 1; }
export function retryableLazy(loader) {
  let version = generation, failed = false;
  const make = () => lazy(() => Promise.resolve().then(loader).catch(error => { failed = true; throw error; }));
  let Component = make();
  return function RetryableRoute(props) {
    if (failed && version !== generation) { version = generation; failed = false; Component = make(); }
    return <Component {...props} />;
  };
}
